/**
 * @fileoverview Review & Analysis index route — overview view
 *
 * URL: /dashboard/jobs/:jobId/review
 *
 * Renders the R&A overview with one card per sub-agent. Mirrors the Data
 * section pattern: the bare phase URL shows an all-agents summary, and
 * clicking a card (or a sidebar sub-item) opens the individual agent's
 * page at /review/$agent.
 */

import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import type { Id } from "@cvx/_generated/dataModel";
import { ReviewOverview } from "@/components/jobs/phases/review/ReviewOverview";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/review/",
)({
  component: ReviewIndex,
});

function ReviewIndex() {
  const { jobId } = Route.useParams();
  const { data: job } = useQuery(
    convexQuery(api.jobs.queries.getJob, { jobId: jobId as Id<"jobs"> }),
  );
  const isViewer = job?.userRole === "viewer";

  // Wrap in the same `p-6` shell used by the Data overview so ReviewOverview's
  // `-m-6` background bleed lines up with the page edges.
  return (
    <div className="flex min-h-full flex-1 flex-col">
      <div className="flex min-h-full flex-1 flex-col p-6">
        <ReviewOverview jobId={jobId} isViewer={isViewer} />
      </div>
    </div>
  );
}
